export default __webpack_public_path__ + "static/media/Yale_University-Logo.wine.0888b26a.svg";